interface ElecProps {
  colour: string;
}

const Elec = ({ colour, ...props }: ElecProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 46 46" {...props}>
    <path
      fill={colour}
      d="M33.827.334H14.594v18.601h5.749v15.26l13.484-20.351h-7.722L33.827.334Zm-1.763 8.077 1.223-2.144.027.013c6.406 3.604 10.734 10.458 10.734 18.338 0 11.629-9.419 21.048-21.048 21.048-11.629 0-21.048-9.419-21.048-21.048 0-7.643 4.091-14.326 10.195-18.009v2.96c-4.67 3.367-7.722 8.853-7.722 15.049a18.51 18.51 0 0 0 5.433 13.129c2.098 2.098 4.699 1.281 7.61.367l.415-.13c1.118-.355 2.289-.698 3.499-.869a10.973 10.973 0 0 1 1.605-.131c1.93 0 3.792.581 5.541 1.127 2.901.906 5.495 1.715 7.588-.377a18.473 18.473 0 0 0 5.446-13.129c0-4.433-1.552-8.485-4.144-11.682a20.09 20.09 0 0 0-1.421-1.565 18.71 18.71 0 0 0-3.933-2.947Z"
    ></path>
  </svg>
);

export default Elec;
